// 繁體中文(台灣用語)— mirrors en.js key for key. zh/ja/ko only use the
// CLDR "other" plural category, so plural entries only carry the _other form.
const zhTW = {
  // ===== shared =====
  'common.createPlan': '建立計劃',
  'common.save': '儲存',
  'common.cancel': '取消',
  'common.delete': '刪除',
  'common.edit': '編輯',
  'common.retry': '重試',
  'common.activate': '啟用',
  'common.deactivate': '停用',
  'common.enabled': '已啟用',
  'common.disabled': '已停用',
  'common.viewTerms': '查看條款',
  'common.untitledPlan': '未命名計劃',
  'common.savedToast': '儲存成功',

  // ===== nav / chrome =====
  'nav.home': '首頁',
  'nav.plans': '計劃',
  'nav.settings': '設定',

  'mismatch.title': '部署環境不符',
  'mismatch.body': '此前端組建呼叫的 API 是 {apiBase},但目前由 {hostname} 提供(預期為 {expected})。',
  'mismatch.contact': '請聯絡技術支援 —— 這是部署設定錯誤,與您的帳號無關。',

  'install.title': '無法連線至 Shopify',
  'install.body': '請確認後端正在執行,且其 SHOPIFY_API_KEY 與 shopify.app.toml 中應用程式的 client_id 一致。',
  'install.retry': '重試',

  'chrome.loadingBrand': 'FlexCover 載入中…',
  'error.title': '發生錯誤',
  'error.reload': '重新載入',

  'support.badge': '客服檢視',
  'support.shopUnknown': '(商店未知)',
  'support.expired': '權杖已過期 —— 請回支援後台重新產生',
  'support.validUntil': '權杖有效期至 {time}',
  'support.exit': '退出',

  // ===== Home =====
  'home.title': '歡迎使用 FlexCover: Protection Plans 👋',
  'home.last30days': '近 30 天',
  'home.loadingChart': '圖表載入中',
  'home.loadingOverview': '總覽載入中',
  'home.statOrders': '含保護計劃的訂單',
  'home.statRevenue': '保護計劃總營收',
  'home.gettingStarted': '新手指南',
  'home.allSet': '全部完成 🎉',
  'home.completed': '已完成 {done}/{total}',
  'home.step1.title': '建立您的第一個保護計劃',
  'home.step1.desc': '設定保護服務的價格、保障範圍與購物車顯示方式。',
  'home.step2.title': '啟用應用程式內嵌',
  'home.step2.desc': '開啟 FlexCover: Protection Plans 區塊,讓保護小工具出現在您的購物車中。',
  'home.step2.enable': '啟用應用程式內嵌',
  'home.step2.check': '檢查狀態',
  'home.step3.title': '取得您的第一筆受保護訂單',
  'home.step3.desc': '小工具上線後,顧客可在購物車中新增保護計劃 —— 總額會顯示在上方卡片中。',
  'home.appEmbed': '應用程式內嵌',
  'home.checkingEmbed': '正在檢查應用程式內嵌狀態',
  'home.embedEnabledBody': '保護小工具已在您的商店前台生效。',
  'home.embedTheme': '(主題:{theme})',
  'home.embedDisabledBody': '應用程式目前在您的商店前台未啟用。',
  'home.embedUnknown': '未知',
  'home.embedUnknownBody': '應用程式與商店連結後,即可查看前台狀態。',
  'home.embedUnknownReason': '目前無法讀取您的線上主題。',
  'home.enableEmbedHint': '在 Shopify 管理介面,依序進入 Online Store → Themes → Customize → App embeds,然後開啟 FlexCover: Protection Plans 開關。',
  'home.learnMorePrefix': '瞭解更多:',
  'home.learnMoreLink': '如何使用保護計劃',

  // ===== Plans list =====
  'plans.title': '計劃',
  'plans.loading': '計劃載入中',
  'plans.errorTitle': '無法載入計劃',
  'plans.empty.heading': '建立您的第一個保護計劃',
  'plans.empty.body': '提供運費保護、延長保固、退貨保障和自訂保障 —— 價格方式由您決定。',
  'plans.loadDemo': '載入範例計劃',
  'plans.demoLoaded': '範例計劃已載入',
  'plans.demoFailed': '載入範例計劃失敗:{message}',
  'plans.filterPlaceholder': '篩選計劃',
  'plans.addFilter': '新增篩選條件',
  'plans.statusHeading': '狀態',
  'plans.typeHeading': '保護類型',
  'plans.statusActive': '已啟用',
  'plans.statusInactive': '已停用',
  'plans.showing_other': '顯示 {count} 個計劃',
  'plans.sortBy': '排序方式',
  'plans.selectAll': '選取全部計劃',
  'plans.selectedCount': '已選取 {count} 項',
  'plans.bulkDeleted_other': '已刪除 {count} 個計劃',
  'plans.bulkActivated_other': '已啟用 {count} 個計劃',
  'plans.bulkDeactivated_other': '已停用 {count} 個計劃',
  'plans.deleteBulkFailed': '刪除失敗:{message}',
  'plans.updateBulkFailed': '更新失敗:{message}',
  'plans.activated': '計劃已啟用',
  'plans.deactivated': '計劃已停用',
  'plans.updateFailed': '更新計劃失敗:{message}',
  'plans.deleted': '計劃已刪除',
  'plans.deleteFailed': '刪除計劃失敗:{message}',
  'plans.actionsFor': '「{name}」的操作',
  'plans.activatePlan': '啟用 {name}',
  'plans.deactivatePlan': '停用 {name}',
  'plans.onlineStore': '線上商店',
  'plans.optional': '可選',
  'plans.automatic': '自動',
  'plans.noMatch': '沒有符合搜尋或篩選條件的計劃。',
  'plans.deleteTitle': '刪除保護計劃?',
  'plans.deleteBody': '將立即從您的商店中移除,顧客將不再看到此保護選項。',
  'plans.helpPrefix': '需要協助?',
  'plans.helpLink': '聯絡我們',
  'plans.helpSuffix': ',或查看應用程式文件和使用者教學。',

  'sort.date': '日期(從新到舊)',
  'sort.name': '名稱(A–Z)',
  'sort.sortOrder': '購物車排序',
  'sort.price': '價格(由低到高)',

  'planType.shipping_protection': '運費保護',
  'planType.warranty': '延長保固',
  'planType.return_insurance': '退貨保障',
  'planType.custom': '自訂保障',
  'planTypeShort.shipping_protection': '運費',
  'planTypeShort.warranty': '保固',
  'planTypeShort.return_insurance': '退貨',
  'planTypeShort.custom': '自訂',
  'priceType.fixed': '固定金額',
  'priceType.percentage': '訂單百分比',

  // ===== Plan editor page shell =====
  'plan.pageTitle': '保護計劃',
  'plan.loading': '計劃載入中',
  'plan.notFound.heading': '找不到計劃',
  'plan.notFound.body': '此保護計劃可能已被刪除。',
  'plan.backToPlans': '返回計劃列表',
  'plan.newTitle': '新增保護計劃',
  'plan.newSubtitle': '設定價格與購物車顯示方式,然後建立計劃',
  'plan.subtitle': '儲存後變更才會套用到您的商店',
  'plan.statusTitle': '計劃狀態',
  'plan.saveFailed': '儲存計劃失敗:{message}',

  // ===== Plan editor form =====
  'form.section.type': '保護類型',
  'form.section.basics': '計劃基本資訊',
  'form.section.pricing': '{type}定價',
  'form.pricingFallback': '保護',
  'form.section.appearance': '外觀',
  'form.section.fulfillment': '履約',

  'form.type.shipping_protection': '運費保護',
  'form.type.shipping_protection.help': '保障顧客訂單在運送途中不遺失、不受損、不被竊。',
  'form.type.warranty': '延長保固',
  'form.type.warranty.help': '對製造瑕疵與正常磨損提供固定期限的保固。',
  'form.type.return_insurance': '退貨保障',
  'form.type.return_insurance.help': '顧客可在期限內退貨並獲得全額退款。',
  'form.type.custom': '自訂保障',
  'form.type.custom.help': '您自訂的保障文案。',

  'form.defaults.untitledPlan': '未命名計劃',
  'form.defaults.viewTerms': '查看條款',
  'form.defaults.shipping_protection.displayName': '運費保護',
  'form.defaults.shipping_protection.description': '保障您的訂單不遺失、不受損、不被竊。',
  'form.defaults.warranty.displayName': '延長保固',
  'form.defaults.warranty.description': '承保製造瑕疵與正常磨損,保固 2 年。',
  'form.defaults.return_insurance.displayName': '退貨保障',
  'form.defaults.return_insurance.description': '14 天內退回任意商品,全額退款,無需理由。',
  'form.defaults.custom.displayName': '保護計劃',
  'form.defaults.custom.description': '為您的訂單添加保障。',

  'form.lang.select': '選擇語言',
  'form.lang.default': '{name}(預設)',
  'form.translated': '(已翻譯)',

  'form.field.planName.label': '計劃名稱(內部)',
  'form.field.planName.help': '僅供您參考 —— 顧客永遠不會看到',
  'form.field.nameRequired': '請輸入內部名稱',
  'form.field.displayName.label': '顯示名稱',
  'form.field.displayNameRequired': '請輸入顯示名稱',
  'form.field.displayName.placeholder': '顯示名稱',
  'form.field.displayName.help': '顯示在購物車與結帳頁面,面向顧客',
  'form.field.displayName.helpPreset': '顯示給使用{lang}瀏覽的顧客',
  'form.field.displayName.helpPresetFallback': '顯示給使用{lang}瀏覽的顧客 —— 留空時回退到{primary}',
  'form.field.description.label': '描述',
  'form.field.description.placeholder': '描述',
  'form.field.description.help': '顯示在計劃名稱下方的簡短顧客文案',
  'form.field.disabledDescription.label': '未勾選時的描述',
  'form.field.disabledDescription.placeholder': '可選 —— 計劃未勾選時顯示',
  'form.field.disabledDescription.help': '計劃核取方塊未勾選時顯示(留空時回退到上方描述)',
  'form.field.footer.label': '頁尾',
  'form.field.footerText.label': '頁尾文字',
  'form.field.footerLink.label': '頁尾連結',
  'form.field.footerLink.help': '頁尾文字的連結網址',

  'form.price.type.label': '價格類型',
  'form.price.fixed': '金額($)',
  'form.price.percentage': '百分比(%)',
  'form.price.advanced': '進階設定',
  'form.price.pctSummary': '訂單金額的 {pct}%,從 ${min} 起、以 ${inc} 遞增,最高至 ${max} —— 計劃商品共 {count} 個變體',
  'form.price.tiersSummary_other': '計劃商品將產生 1 個 {base} 變體,另加 {count} 個購物車金額區間變體',

  'form.validation.priceRequired': '請輸入大於 0 的數值',
  'form.validation.priceMax100': '百分比不能超過 100',
  'form.validation.warrantyYears': '請輸入 1 到 5 年之間的期限',
  'form.validation.returnDays': '請輸入 7 到 365 天之間的期限',
  'form.validation.maxGreaterThanMin': '最大值必須大於最小值',
  'form.validation.variantIdNumeric': '變體 ID 必須為數字(隱藏計劃變體的 ID)',

  'form.icon.label': '圖示',
  'form.icon.useEmoji': '使用 {emoji} 作為計劃圖示',
  'form.icon.removeCustom': '移除自訂圖示,恢復使用盾牌圖示',
  'form.icon.upload': '上傳自訂圖示圖片',
  'form.icon.uploadButton': '上傳',
  'form.icon.uploading': '圖示上傳中',
  'form.icon.uploadHelp': '上傳您自己的圖示 —— 支援 PNG、JPEG、GIF 或 WebP,最大 5 MB。',
  'form.icon.error.notImage': '請選擇圖片檔案(PNG、JPEG、GIF 或 WebP)。',
  'form.icon.error.tooLarge': '圖片必須小於或等於 5 MB。',

  'form.fulfillment.intro': '選擇保護商品何時被標記為已履約。',
  'form.fulfillment.manually': '手動履約',
  'form.fulfillment.first_item': '訂單中第一項商品履約時標記為已履約',
  'form.fulfillment.all_items': '訂單中所有其他商品履約時標記為已履約',
  'form.fulfillment.immediately': '訂單建立後立即標記為已履約',

  'form.adv.title': '進階設定',
  'form.adv.minPrice': '最低價格',
  'form.adv.minPriceHelp': '第一個變體的價格 —— 計劃收取的最低費用',
  'form.adv.increment': '遞增金額',
  'form.adv.incrementHelp': '產生的變體之間的價格間距',
  'form.adv.maxPriceLabel': '最高價格:',
  'form.adv.explanation': '計劃商品將產生 {buckets} 個變體:{min} 佔一個變體,其餘 {rest} 個變體以 {inc} 遞增,最高價格為 {max}。結帳時顧客支付首個不低於購物車小計 {pct}% 的變體 —— 例如 $100 的購物車按 2% 計算目標為 $2.00,因此適用 $3.01 的變體。 ',
  'form.learnMore': '瞭解更多',

  'form.tiers.title': '按購物車金額定價',
  'form.tiers.minCol': '購物車最小金額',
  'form.tiers.maxCol': '購物車最大金額',
  'form.tiers.priceCol': '保護價格',
  'form.tiers.addTier': '新增規則',
  'form.tiers.deleteTier': '刪除規則 {index}',
  'form.tiers.explanation': '每條規則都需要最小值、最大值和價格(規則可以重疊 —— 按第一條符合的規則生效)。每條規則會在計劃商品上產生獨立變體。若購物車總額不符合任何規則,則適用主設定中的固定價格。 ',
  'form.tiers.error.minRequired': '請輸入購物車最小金額',
  'form.tiers.error.maxRequired': '請輸入購物車最大金額',
  'form.tiers.error.priceRequired': '請輸入保護價格',
  'form.tiers.error.pricePositive': '價格必須大於 0',
  'form.tiers.error.minMax': '最小值必須小於或等於最大值',

  // ===== Save bar =====
  'savebar.unsavedChanges': '有未儲存的變更',
  'savebar.discard': '捨棄',
  'savebar.saving': '儲存中',

  // ===== Preview panel =====
  'preview.title': '預覽',
  'preview.simulatedSubtotal': '模擬購物車小計',
  'preview.cart': '購物車',
  'preview.product': '商品',
  'preview.total': '總計',
  'preview.subtotal': '小計',
  'preview.checkout': '結帳',
  'preview.noPlans': '暫無啟用的計劃 —— 顧客不會看到此小工具。',
  'preview.autoAdded': '自動加入',
  'preview.unsaved': '未儲存',

  // ===== Settings page =====
  'settings.title': '設定',
  'settings.language.title': '語言偏好',
  'settings.language.help': '當您造訪 FlexCover 時,這是為您顯示的語言。您商店的語言不會受到影響。',
  'settings.language.label': '語言',
  'settings.language.updated': '語言已更新',
  'settings.language.saveFailed': '儲存語言偏好失敗:{message}'
};

export default zhTW;
